import Vue from 'vue'

Vue.component('icon-pram', require('./pram').default)
Vue.component('icon-weel', require('./weel').default)
Vue.component('icon-toy', require('./toy').default)
Vue.component('icon-bottle', require('./bottle').default)
Vue.component('icon-sun', require('./sun').default)
Vue.component('icon-cloud', require('./cloud').default)
Vue.component('icon-arrow', require('./arrow').default)
Vue.component('icon-slide-arrow', require('./slide-arrow').default)
Vue.component('icon-vk', require('./vk').default)
Vue.component('icon-fb', require('./fb').default)
Vue.component('icon-tw', require('./tw').default)
Vue.component('icon-ok', require('./ok').default)
